<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você poderá criar um novo fundo de investimentos, seja de
              aceleração ou de pré-aceleração. Para isso é necessário preencher
              as informações iniciais abaixo. Novos investidores e batches podem
              ser vinculados ao fundo a partir de páginas específicas.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--8">
      <div class="row">
        <div class="col-xl-8">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">Fundo de investimentos</h3>
                </div>
              </div>
            </div>
            <template>
              <form @submit.prevent>
                <h6 class="heading-small text-muted mb-4">
                  Informações básicas
                </h6>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-12">
                      <base-input label="Tipo">
                        <br />
                        <base-radio
                          name="Aceleração"
                          class="mb-3"
                          v-model="model.type"
                          :inline="true"
                        >
                          Aceleração
                        </base-radio>
                        <base-radio
                          name="Pré-aceleração"
                          class="mb-3"
                          v-model="model.type"
                          :inline="true"
                        >
                          Pré-aceleração
                        </base-radio>
                        <base-radio
                          name="Misto"
                          class="mb-3"
                          v-model="model.type"
                          :inline="true"
                        >
                          Misto
                        </base-radio>
                      </base-input>
                    </div>
                  </div>
                </div>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group has-label">
                        <label
                          class="form-control-label form-control-label-full"
                          >Nome do fundo (tag)
                          <span
                            @click="handleEditTag"
                            class="btn btn-link btn-sm btn-edit pt-0 pb-0 bb-0 border-bottom-0 border-top-0 float-right"
                          >
                            {{ editTag ? "usar tag padrão" : "editar" }}
                          </span>
                        </label>
                        <base-input
                          placeholder="Se não editado, será gerado automaticamente"
                          input-classes="form-control"
                          addon-left-icon="ni ni-tag"
                          v-model="model.tag"
                          :disabled="!editTag"
                          :disabled-icon-box="!editTag"
                        />
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label">
                        Status do fundo
                        <i
                          v-if="model.status"
                          class="fas fa-info-circle ml-1"
                          :title="getStatusDescription"
                        ></i>
                      </label>
                      <div>
                        <base-input addon-left-icon="fas fa-cogs">
                          <select class="form-control" v-model="model.status">
                            <option selected disabled value="">
                              Selecione o status do fundo
                            </option>
                            <option
                              v-for="status in fundStatus"
                              :key="status.key"
                              :value="status.key"
                            >
                              {{ status.value }}
                            </option>
                          </select>
                        </base-input>
                      </div>
                    </div>
                  </div>
                  <estados
                    estadoLabel="Estado origem do fundo"
                    cidadeLabel="Cidade origem do fundo"
                    :selectedEstado="model.state"
                    :selectedCidade="model.city"
                    @inputEstado="model.state = $event"
                    @inputCidade="model.city = $event"
                  />
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group has-label">
                        <label class="form-control-label">Data de início</label>
                        <base-input
                          type="date"
                          placeholder="Data fim"
                          input-classes="form-control"
                          addon-left-icon="ni ni-calendar-grid-58"
                          v-model="model.start_date"
                        />
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group has-label">
                        <label class="form-control-label">Data fim</label>
                        <base-input
                          type="date"
                          placeholder="Data fim"
                          input-classes="form-control"
                          addon-left-icon="ni ni-calendar-grid-58"
                          v-model="model.end_date"
                        />
                      </div>
                    </div>
                    <div class="col-12">
                      <span class="duration">
                        {{ calcDuration() }}
                      </span>
                    </div>
                  </div>
                </div>
                <hr class="my-4" />
                <h6 class="heading-small text-muted mb-4">
                  Informações complementares
                </h6>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-lg-4">
                      <base-input label="Valor total previsto do fundo">
                        <div class="input-unit-box">
                          <input
                            type="text"
                            placeholder="Valor do fundo"
                            class="form-control input-unit"
                            v-model="model.value"
                          />
                          <span class="unit">R$ </span>
                        </div>
                      </base-input>
                    </div>
                    <div class="col-lg-4">
                      <div class="form-group has-label">
                        <label class="form-control-label"
                          >Número previsto de batches</label
                        >
                        <base-input
                          type="number"
                          placeholder="Número de batches"
                          input-classes="form-control"
                          addon-left-icon="ni ni-money-coins"
                          v-model="model.batches"
                        />
                      </div>
                    </div>
                    <div class="col-lg-4">
                      <div class="form-group has-label">
                        <label class="form-control-label"
                          >Número previsto de investidores</label
                        >
                        <base-input
                          type="number"
                          placeholder="Número de investiores"
                          input-classes="form-control"
                          addon-left-icon="fa fa-user-tie"
                          v-model="model.number_investors"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <span class="quota">
                      {{ calcQuota() }}
                    </span>
                  </div>
                </div>
                <hr class="my-4" />
                <!-- Description -->
                <div class="pl-lg-4">
                  <div class="form-group">
                    <base-input label="Descrição (opicional)">
                      <textarea
                        rows="3"
                        class="form-control form-control"
                        placeholder="Digite aqui..."
                        v-model="model.description"
                      >
                      </textarea>
                    </base-input>
                  </div>
                </div>
              </form>
            </template>
          </card>
        </div>
        <div class="col-xl-4 order-xl-1 mb-5 mb-xl-0 mt-6 mt-lg-0">
          <div class="card card-profile shadow">
            <div class="row justify-content-center">
              <div class="col-lg-3 order-lg-2">
                <div class="card-profile-image">
                  <img src="/img/pages/fund.png" class="rounded-circle" />
                </div>
              </div>
            </div>
            <div class="card-header text-center border-0">
              <div class="d-flex justify-content-between"></div>
            </div>
            <div class="card-body pt-5 pt-md-4 pb-4">
              <div class="row">
                <div class="col">
                  <div
                    class="card-profile-stats d-flex justify-content-center mt-md-5"
                  >
                    <div>
                      <span class="heading">{{ model.batches || "-" }}</span>
                      <span class="description">Batches</span>
                    </div>
                    <div>
                      <span class="heading">{{
                        formatValue(model.value)
                      }}</span>
                      <span class="description">Valor</span>
                    </div>
                    <div>
                      <span class="heading">{{
                        model.number_investors || "-"
                      }}</span>
                      <span class="description">Investidores</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-center">
                <h3>
                  Cidade: <span class="font-weight-light"> {{ local() }}</span>
                </h3>
                <h3>
                  Fundo válido de:
                  <span class="font-weight-light">
                    {{ getYear(this.model.start_date) }} até
                    {{ getYear(this.model.end_date) }}
                  </span>
                </h3>
                <hr class="my-4" />
                <h2 class="text-center tag-title">
                  <i class="ni ni-tag"></i>
                  <span class="tag">{{ model.tag || tag() }}</span>
                </h2>
                <div class="col-12 text-center" v-if="error">
                  <base-alert type="danger">{{ error }}</base-alert>
                </div>
                <base-button type="danger" :custom="true" @click="handleCreate"
                  >Criar fundo</base-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <modal
        :show.sync="modals.confirmation"
        :closeOnClick="modals.closeOnClick"
        modal-classes="modal-default modal-dialog-centered"
      >
        <h6 slot="header" class="modal-title" id="modal-title-notification">
          Atenção!
        </h6>
        <div class="vld-parent" ref="modal_confirmation_create">
          <div class="text-center py-3">
            <i class="fas fa-coins fa-3x"></i>
            <h4 class="heading mt-4">Confirmar criação de novo fundo</h4>
            <p>
              Você realmente deseja criar o fundo de investimentos
              <b class="font-weight-bold">{{ model.tag }}</b
              >?
            </p>
            <p class="text-sm mt-3 mx-2">
              <i class="fas fa-info-circle mr-1"></i> Lembre-se, após a criação
              será possível vincular os investidores ao fundo.
            </p>
          </div>
        </div>
        <template slot="footer">
          <base-button
            type="link"
            text-color="white"
            class="ml-auto"
            @click="modals.confirmation = false"
          >
            Voltar
          </base-button>
          <base-button type="white" @click="handleSubmit">
            Confirmar
          </base-button>
        </template>
      </modal>
    </div>
  </div>
</template>
<script>
import api from "@/services/api.js";

export default {
  name: "fundo",
  data() {
    return {
      model: {
        type: "",
        tag: "",
        state: "",
        city: "",
        start_date: "",
        end_date: "",
        value: "",
        batches: "",
        number_investors: "",
        description: "",
        status: "",
      },
      fundStatus: [
        {
          key: "open",
          value: "Regular",
          description:
            "Um fundo regular fica visível para os investidores cadastrados no fundo.",
        },
        {
          key: "closed",
          value: "Encerrado",
          description:
            "O status 'Encerrado' ficará visível para os investidores cadastrados no fundo.",
        },
        {
          key: "hidden",
          value: "Invisível",
          description:
            "Um fundo invisível fica oculto para todos os investidores.",
        },
      ],
      editTag: false,
      error: "",
      modals: {
        confirmation: false,
        closeOnClick: true,
      },
    };
  },
  methods: {
    handleCreate() {
      this.error = "";
      if (!this.editTag && this.model.tag == "") this.model.tag = this.tag();
      const data = this.model;
      for (const key in data) {
        if (key !== "description" && data[key] === "") {
          this.error =
            "Por favor, preencha todos os campos antes de continuar.";
          return;
        }
      }
      this.modals.confirmation = true;
    },
    async handleSubmit() {
      this.modals.closeOnClick = false;
      let loader = this.$loading.show({
        container: this.$refs.modal_confirmation_create,
        opacity: 0,
        width: 140,
        height: 140,
      });
      try {
        await api.post("/funds", this.model);
        this.$toasted.show("Novo fundo criado com sucesso");
        this.$router.push({ name: "admin_fundos" });
      } catch (e) {
        this.error =
          "Ocorreu um erro ao registar o fundo. Verifique as informações e tente novamente.";
        this.$toasted.error("Ocorreu um erro ao salvar as informações");
      } finally {
        this.modals.confirmation = false;
        this.modals.closeOnClick = true;
        loader.hide();
      }
    },
    calcQuota() {
      const numValue = Number(this.model.value);
      const numInvestors = Number(this.model.number_investors);
      if (numValue > 0 && numInvestors > 0) {
        const msg = "* Valor médio da quota: ";
        return msg + this.formatValue(numValue / numInvestors);
      }
    },
    local() {
      if (this.model.state) {
        if (this.model.city) return `${this.model.city}, ${this.model.state}`;
        else return this.model.state;
      }
      return "...";
    },
    handleEditTag() {
      this.editTag = !this.editTag;
      const shouldSuggestTag =
        this.editTag &&
        this.model.type &&
        this.model.city &&
        this.model.start_date;
      this.model.tag = shouldSuggestTag ? this.tag() : "";
    },
    calcDuration() {
      if (this.model.start_date && this.model.end_date) {
        const d1 = this.moment(this.model.start_date);
        const d2 = this.moment(this.model.end_date);
        let diffDays = d2.diff(d1, "days");
        if (diffDays <= 0) return "Data fim deve ser maior que data de início";
        return `* Validade do fundo: ${diffDays} dias`;
      }
    },
    tag() {
      let prefixType, prefixCity, start_dateYear;
      if (this.model.type) {
        if (this.model.type === "Aceleração") prefixType = "ACEL";
        else if (this.model.type === "Pré-aceleração") prefixType = "PRE_ACEL";
        else prefixType = "MISTO";
      }
      if (this.model.city) {
        prefixCity = this.model.city
          .replace(/ /g, "")
          .substring(0, 3)
          .toUpperCase();
        //.map(w => w.charAt(0).toUpperCase())
        // .join("");
      }
      if (this.model.start_date)
        start_dateYear = this.getYear(this.model.start_date);
      return [prefixType, prefixCity, this.model.state, start_dateYear]
        .filter(Boolean) // w => w != null
        .join("_");
    },
  },
  computed: {
    getStatusDescription() {
      const selectedStatus = this.fundStatus.find(
        (status) => status.key === this.model.status
      );
      return selectedStatus ? selectedStatus.description : "";
    },
  },
};
</script>
<style scoped>
.input-unit-box {
  position: relative;
}

.form-control-label-full {
  width: 100%;
}

.input-unit {
  display: block;
  border: 1px solid #d7d6d6;
  background: #fff;
  padding: 10px 10px 10px 30px;
}

.unit {
  position: absolute;
  display: block;
  left: 5px;
  top: 10px;
  z-index: 9;
  color: #444444;
}

.duration,
.quota {
  font-size: 12px;
  color: #444444;
  text-transform: uppercase;
}

.duration,
.quota,
.tag {
  font-family: inherit;
  font-weight: 600;
  line-height: 1.5;
}

.tag {
  font-size: 18px;
  margin-left: 1em;
  color: black;
}

.tag-title {
  margin-bottom: 1.2em;
}
</style>
